import { NavLink, Link } from "react-router-dom";
import { Github, Linkedin, Mail } from "lucide-react";

const links = [
  { label: "Home", to: "/" },
  { label: "About me", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Contact me", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-black text-white border-t border-gray-800">
      {/* Main footer body */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand col */}
          <div className="md:col-span-1 flex flex-col gap-4">
            <div className="text-2xl font-bold">
              <span className="text-white">PORT</span>
              <span className="text-blue-400">FOLIO</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              Full-stack developer building clean, scalable web products from
              the ground up.
            </p>
            {/* Social links */}
            <div className="flex items-center gap-3 mt-1">
              {[
                {
                  icon: <Github size={15} />,
                  href: "https://github.com/jedidahnzila",
                },
                {
                  icon: <Linkedin size={15} />,
                  href: "https://www.linkedin.com/in/jedidah-nzila-a921a6321/",
                },
                {
                  icon: <Mail size={15} />,
                  href: "mailto:nzilajedidah@gmail.com",
                },
              ].map(({ icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="w-8 h-8 rounded-lg border border-gray-800 flex items-center justify-center text-gray-400 hover:text-white hover:border-gray-600 transition-colors"
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Nav col */}
          <div className="flex flex-col gap-3">
            <p className="text-[10px] font-medium text-gray-500 tracking-widest uppercase mb-1">
              Navigation
            </p>
            {links.map(({ label, to }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                className={({ isActive }) =>
                  `text-sm transition-colors w-fit ${
                    isActive
                      ? "text-blue-400"
                      : "text-gray-400 hover:text-white"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>

          {/* CTA col */}
          <div className="flex flex-col gap-3">
            <p className="text-[10px] font-medium text-gray-500 tracking-widest uppercase mb-1">
              Work with me
            </p>
            <p className="text-sm text-gray-400 leading-relaxed">
              Open to freelance projects and full-time opportunities.
            </p>
            <Link
              to="/contact"
              className="self-start mt-1 inline-flex items-center gap-2 bg-white text-black text-sm font-medium px-5 py-2.5 rounded-full hover:bg-blue-600 hover:text-white transition-colors duration-200"
            >
              Let's talk
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Jedidah Nzila. All rights reserved.
          </p>
          <p className="text-xs text-gray-600">
            Designed & built by Jedidah Nzila
          </p>
        </div>
      </div>
    </footer>
  );
}
